import { css } from '@emotion/core'

/**
 * 室料金設定モーダル共通の全画面オーバーレイ。
 * Header(102)・SideMenu(103)より上に被せる。上寄せスクロール配置。
 */
export const roomRateModalOverlayStyle = css({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(0, 0, 0, 0.5)',
  zIndex: 104,
  overflowY: 'auto',
  color: '#272727',
})

/** atoms/Modal 本体と同様の上余白 + 水平中央 */
export const roomRateModalPanelPlacementStyle = css({
  margin: '32px auto',
})

/** ピル型 Select（ベースレート / アサイン室料金モーダル） */
export const roomRatePillSelectStyle = css({
  paddingBottom: 0,
  '> div': {
    borderRadius: '30px !important',
    height: '32px !important',
  },
  '.ant-select-selection__rendered': {
    lineHeight: '30px !important',
    marginLeft: '16px !important',
    fontSize: 14,
    fontWeight: 500,
    color: '#272727',
  },
})

/** react-dates の portal は z-index が無く、室料金モーダル（104 以上）の後ろに隠れる */
export const roomRatePickerPortalStyle = css({
  '.DateRangePicker_picker__portal, .SingleDatePicker_picker__portal': {
    zIndex: 400,
  },
})

/** 設定モーダル本文（背景・余白）。スクロール等は呼び出し側で上書き */
export const roomRateModalSectionStyle = css({
  background: '#F2F2F2',
  padding: '32px',
})
